import { render, staticRenderFns } from "./Slo.vue?vue&type=template&id=6fce20b8"
import script from "./Slo.vue?vue&type=script&lang=js"
export * from "./Slo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports